import { IUserAction } from "./actions/userAction";
import {
  GuestType,
  IAuthorization,
} from "./types/userTypes";
import {UserState} from "../passapp-sdk/types/userTypes";

export const userInitialState: UserState = {
  accessPrevalidationStatus: "",
  firstname: "",
  lastname: "",
  countryCode: "",
  dni: "",
  old: {
    firstname: "",
    lastname: "",
    countryCode: "",
    dni: "",
    driverLicenseExpirationDate: "",
    workMaterials: "",
    artCompanyName: "",
    artPolicyNumber: "",
    artExpirationDate: "",
    criminalRecordIssueDate: "",
    professionTypes: [],
  },
  bicyclePhoto: "",
  observationsPhoto: "",
  observationsPhoto2: "",
  observationsPhoto3: "",
  facePhoto: "",
  frontDNI: "",
  backDNI: "",
  isResident: false,
  registrationType: "basic",
  id: "",
  config: null,
  authorizations: [],
  eventId: "",
  blacklistedData: null,
  isBlackList: false,
  isPassForeign: false,
  residences: [],
  residencesInfo: [],
  professionTypes: [],
  workMaterials: "",
  artCompanyName: "",
  artPolicyNumber: "",
  artExpirationDate: "",
  artPhoto1: "",
  artPhoto2: "",
  criminalRecordIssueDate: "",
  criminalRecordPhoto1: "",
  criminalRecordPhoto2: "",
  otherCertificateDescription: "",
  otherCertificateExpirationDate: "",
  otherCertificatePhoto1: "",
  otherCertificatePhoto2: "",
  searchCompanion: undefined,
  companions: [],
  vehicleType: "",
  vehicleSelected: {
    model: "",
    brand: "",
    plate: "",
    color: "",
    insuranceExpirationDate: "",
    insurancePhoto: "",
    insurancePhotoNew: null,
    id: "",
  },
  showCompanionSection: false,
  showDialogCompanion: false,
  vehicles: [],
  isNewVehicle: false,
  loadingVehicle: false,
  frontDriverLicense: "",
  backDriverLicense: "",
  frontDriverLicensePhoto: "",
  backDriverLicensePhoto: "",
  driverLicenseExpirationDate: "",
  transportEmployeeNumber: "",
  transportEmployeeNumbers: [],
  comment: "",
  permanentComment: "",
  commentReject: "",
  underagedCount: "0",
  blacklistAuthorization: "",
  isDriver: false,
  loading: false,
  isExit: false,
  isPass: "",
  isUnknown: false,
  isTogglable: false,
  isInvalidInsuranceExpirationDate: false,
  isInvalidArtExpirationDate: false,
  isInvalidCriminalRecordIssueDate: false,
  isInvalidDriverLicenseExpirationDate: false,
  indexTab: -2,
  lastSelectionAuthorizationType: GuestType.any,
};

const hideCoincidence = (id: string, object: IAuthorization[]) => {
  for (let i = object.length - 1; i >= 0; i--) {
    if (object[i].authorization.host?.id === id) {
      object[i].hidden = true;
      object[i].mark = false;
    }
  }
};

const toggleAll = (value: GuestType, object: IAuthorization[]) => {
  for (let i = 0; i < object.length; i++) {
    object[i].guestType = value;
  }
};

export const userReducer = (
  state: UserState = userInitialState,
  action: IUserAction<any>
): UserState => {
  switch (action.type) {
    case "USER_ADD_AUTHORIZATION": {
      // hideCoincidence(
      //   action.payload.authorization.host?.id,
      //   state.authorizations
      // );
      return {
        ...state,
        authorizations:
          state.authorizations.find(
            (item) =>
              item.id === action.payload.id && item.type === action.payload.type
          ) === undefined
            ? state.authorizations.concat(action.payload)
            : state.authorizations,
      };
    }
    case "USER_MARK_AUTHORIZATION": {
      let founded = state.authorizations.find(
        (item) =>
          item.id === action.payload.id && item.type === action.payload.type
      );
      if (founded) founded.mark = action.payload.value;
      return {
        ...state,
      };
    }
    case "USER_TOGGLE_AUTHORIZATION": {
      if (!state.isTogglable) {
        toggleAll(action.payload.value, state.authorizations);
        state.isTogglable = true;
        state.lastSelectionAuthorizationType = action.payload.value;
      } else {
        let founded = state.authorizations.find(
          (item) =>
            item.id === action.payload.id && item.type === action.payload.type
        );
        if (founded) founded.guestType = action.payload.value;
      }
      return {
        ...state,
      };
    }
    case "USER_HIDDEN_AUTHORIZATION": {
      let founded = state.authorizations.find(
        (item) =>
          item.id === action.payload.id && item.type === action.payload.type
      );
      if (founded) founded.hidden = !founded.hidden;
      return {
        ...state,
      };
    }

    case "USER_CHANGE_NAME": {
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };
    }
    case "USER_IS_BLACK_LIST": {
      return {
        ...state,
        isBlackList: true,
      };
    }
    case "USER_IS_RESIDENT": {
      return {
        ...state,
        isResident: true,
      };
    }
    case "USER_SET_SEARCH_COMPANION": {
      return {
        ...state,
        searchCompanion: action.payload,
      };
    }
    case "USER_ADD_COMPANION": {
      if (!state.companions) state.companions = [];
      return {
        ...state,
        companions: state.companions.concat(action.payload),
      };
    }
    case "USER_DELETE_COMPANION": {
      return {
        ...state,
        companions: state.companions.filter(
          (item) => item.id !== action.payload
        ),
      };
    }
    case "USER_RESET": {
      return userInitialState;
    }
    case "USER_SELECT_TYPE_VEHICLE":
      return {
        ...state,
        vehicleType: action.payload,
      };
    case "USER_SELECT_VEHICLE":
      return {
        ...state,
        vehicleSelected: action.payload,
      };
    case "USER_RESET_SELECT_VEHICLE":
      return {
        ...state,
        vehicleSelected: {
          model: "",
          brand: "",
          plate: "",
          color: "",
          insuranceExpirationDate: "",
          insurancePhoto: "",
          insurancePhotoNew: null,
          id: "",
        },
      };
    case "USER_SHOW_COMPANION_SECTION":
      return {
        ...state,
        showCompanionSection: action.payload,
      };
    case "USER_SET_VEHICLES":
      return {
        ...state,
        vehicles: action.payload,
      };
    case "USER_NOT_NEW_VEHICLE":
      return {
        ...state,
        isNewVehicle: false,
      };
    case "USER_SHOW_DIALOG_COMPANION":
      return {
        ...state,
        showDialogCompanion: action.payload,
      };
    case "USER_VEHICLE_START_LOADING":
      return {
        ...state,
        loadingVehicle: true,
      };
    case "USER_VEHICLE_STOP_LOADING":
      return {
        ...state,
        loadingVehicle: false,
      };
    case "USER_VEHICLE_FIELD_CHANGES": {
      return {
        ...state,
        vehicleSelected: {
          ...state.vehicleSelected,
          [action.payload.name]: action.payload.value,
        },
      };
    }
    case "USER_VEHICLE_NEW_LOCAL_PHOTO": {
      let vehicle = state.vehicles.find(
        (item) => item.id === action.payload.id
      );
      if (vehicle) vehicle.insurancePhotoNew = action.payload.photo;
      return {
        ...state,
      };
    }
    case "USER_BLACKLIST_AUTHORIZATION": {
      return {
        ...state,
        blacklistAuthorization: action.payload,
        isBlackList: false,
      };
    }
    case "USER_MARK_EXIT": {
      if (state.id === action.payload) state.isExit = true;
      else {
        state.companions.forEach((companion) => {
          if (companion.id === action.payload) companion.isExit = true;
        });
      }
      return {
        ...state,
      };
    }
    case "USER_EDIT_EXIT": {
      delete action.payload.config;
      if (state.id === action.payload.id)
        state = { ...state, ...action.payload };
      else {
        let companions = state.companions.map((companion) => {
          if (companion.id === action.payload.id) {
            companion = { ...companion, ...action.payload };
          }
          return companion;
        });
        state.companions = companions;
      }
      return {
        ...state,
      };
    }
    case "USER_ACEPT_UNKNOWN": {
      return { ...state, isUnknown: false };
    }
    default:
      return state;
  }
};
